import React from 'react';

const SvgPersons = props => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <defs>
      <style>
        {'.persons_svg__a{fill:none;stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
      </style>
    </defs>
    <rect
      className="persons__a"
      style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
      width={8}
      height={11}
      rx={4}
      transform="translate(12 8)"
    />
    <path
      className="persons__a"
      style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
      d="M14 19v1.681a2 2 0 01-1.212 1.838l-4.576 1.962A2 2 0 007 26.319V29M18 19v1.681a2 2 0 001.212 1.838l4.576 1.962A2 2 0 0125 26.319V29M6.5 11A2.523 2.523 0 014 8.455v-2.91A2.523 2.523 0 016.5 3 2.523 2.523 0 019 5.545v2.91A2.523 2.523 0 016.5 11zM5 11v1.219a1 1 0 01-.757.97l-1.728.432A2 2 0 001 15.562V18M8 11v1.219a1 1 0 00.757.97L9 13.25M25.5 11A2.523 2.523 0 0028 8.455v-2.91A2.523 2.523 0 0025.5 3 2.523 2.523 0 0023 5.545v2.91A2.523 2.523 0 0025.5 11zM27 11v1.219a1 1 0 00.757.97l1.728.432A2 2 0 0131 15.562V18M24 11v1.219a1 1 0 01-.757.97L23 13.25"
    />
    <path fill="none" d="M0 0h32v32H0z" />
  </svg>
);

export default SvgPersons;
